import { InvitationEntity } from "./InvitationEntity";

export class ChargeAccountInvitationEntity extends InvitationEntity {
  chargeAccountData;

  constructor(
    inviterName,
    inviterId,
    email,
    phone,
    scopeId,
    roleId,
    scopeName,
    invitationType,
    chargeAccountData
  ) {
    super(inviterName, inviterId, email, phone, scopeId, roleId, scopeName, invitationType);
    this.chargeAccountData = chargeAccountData
  }
}
